import 'bootstrap';
import 'bootstrap-select';


$(document).on('click', '.radio-reabo', function () {
  var checkbox = $("input[name=radio-duree-offer]");
  checkbox.attr('checked', false);
  this.checked = true;
});

$(document).on('click', '.valider_reabo', function (e) {
  e.preventDefault();

  var form = $(this).parents('#formSubmitOffer');
  var isChecked = form.find("input[name=radio-duree-offer]").is(':checked');

  if (isChecked === false) {
    alert('Merci de sÃ©lectionner une valeur avant de continuer');

  } else {
    form.submit();
  }
});


$(document).on('click', '#create-account .viewMdp', function(){
  let self = $(this);
  console.log(self);
  if($("input", self.parent()).attr("type") == "password")
  {
    self.html('Cacher le mot de passe');
    $("input", self.parent()).attr("type", "text");
  }
  else
  {
    self.html('Voir le mot de passe');
    $("input", self.parent()).attr("type", "password");
  }
});

$(document).on('click', '#alternativeeconomique_submit_form', function() {

  var firstInputInvalid = "";
  $("#sign-up-form input:invalid:first-child").each(function(){
    if(!firstInputInvalid)
    {
      firstInputInvalid = $(this);
    }
    if(firstInputInvalid)
    {
      $("html, body").stop().animate({scrollTop: (firstInputInvalid.offset().top-50)}, {duration: 250 });
    }
  });
});

$(document).on('click', '.btn-open-modal-add-offer', function (e) {
  var titreOffreModal = $('.titreOffreModal');
  var infoOffreModal = $('.infoOffreModal');
  var imgOffreModal = $('.imgOffreModal');
  var prixOffreModal = $('.prixOffreModal');

  var keepGoing = true;
  var nbRadioGift = $("input[name='choiceGiftId']").length;
  var checkedRadio = $("input[name='choiceGiftId']:checked");
  var oneGiftIsSelected = checkedRadio.length;

  var giftId = '';
  if (nbRadioGift > 0) {
    if (oneGiftIsSelected < 1) {
      alert('Merci de choisir votre cadeau');
      keepGoing = false;
    } else {
      giftId = checkedRadio.val();
    }
  }

  if (keepGoing) {
    titreOffreModal.empty();
    infoOffreModal.empty();
    imgOffreModal.attr('src', '');
    prixOffreModal.empty();

    var parentDiv = $(this).parents('.offreBloc');

    var attrId = $(this).attr('id');
    if (typeof attrId !== typeof undefined && attrId !== false) {
      var offer = $(this).attr('id');
      var idOffer = offer.split('-')[1];
      var type = offer.split('-')[0];
    }

    //var plId = $(this).data('plid');
    var dataId = $(this).data('id');
    var zoneId = '';
    var typeOffer = $('#typeOffer');

    typeOffer.attr('value', 'product');
    if (type === 'offer') {
      typeOffer.attr('value', 'abonnement');
      zoneId = $(this).data('zoneid');
    } else if (type === 'product') {
      typeOffer.attr('value', 'product');
    }

    var inputOfferId = $('#idOffer');
    var inputDataId = $('#dataId');
    var inputZoneId = $('#zoneId');
    var inputGiftId = $('#giftId');

    inputOfferId.attr('value', '');
    inputDataId.attr('value', '');
    inputZoneId.attr('value', '');
    inputGiftId.attr('value', '');
    if (idOffer) {
      inputOfferId.attr('value', idOffer);
    }
    if (zoneId) {
      inputZoneId.attr('value', zoneId);
    }
    if (dataId) {
      inputDataId.attr('value', dataId);
    }
    if (giftId) {
      inputGiftId.attr('value', giftId);
    }
    //$('#pageLayoutId').attr('value', plId);


    var titreOffre = parentDiv.find('.titreOffre').html();
    var infoOffre = parentDiv.find('.infoOffre').html();
    var imgOffre = parentDiv.find('.imgOffre').attr('src');
    var prixOffre = $(this).hasClass('double_offre') ? $(this).find('.prixOffre').html() : parentDiv.find('.prixOffre').html();
    var otherPrixOffre = parentDiv.find('.prixOffre').html();
    //var doublePrice = otherPrixOffre.indexOf('ou') >= 0;

    titreOffreModal.html(titreOffre);
    infoOffreModal.html(infoOffre);
    imgOffreModal.attr('src', imgOffre);
    prixOffreModal.html(prixOffre);
    //if (doublePrice == false) {
    var cashPart = $('.paiement-cash');
    var cashRadio = $('#radio-cash');
    var labelCash = $('div.paiement-cash > label');
    var prelevementPart = $('.paiement-prelevement');
    var prelevementRadio = $('#radio-prelevement');
    var labelPrelevement = $('div.paiement-prelevement > label');
    var titre = parentDiv.find('.titreOffre');
    var form = $('formSubmitOffer');
    $('#info-prelevement').remove();
    $('#info-cash').remove();
    if (!titre.hasClass('cash') && titre.hasClass('prelevement')) {
      form.css('display', 'block');
      cashPart.css('display', 'none');
      prelevementPart.css('display', 'block');
      // Hide radio prelevement
      prelevementRadio.attr('checked', true);
      prelevementRadio.prop("checked", true);
      prelevementRadio.css('display', 'none');
      /*prelevementPart.append('<p id="info-prelevement"><br/>Vous allez payer par prÃ©lÃ¨vement mensuel</p>');*/
      labelPrelevement.css('display', 'none');
    } else if (!titre.hasClass('prelevement') && titre.hasClass('cash')) {
      form.css('display', 'block');
      cashPart.css('display', 'block');
      prelevementPart.css('display', 'none');
      // Hide radio cash
      cashRadio.attr('checked', true);
      cashRadio.prop("checked", true);
      cashRadio.css('display', 'none');
      /*cashPart.append('<p id="info-cash"><br/>Vous allez payer en une seule fois</p>');*/
      labelCash.css('display', 'none');
    } else if (titre.hasClass('prelevement') && titre.hasClass('cash')) {
      form.css('display', 'block');
      cashPart.css('display', 'block');
      cashRadio.css({"display": "block", "position": "absolute"});
      labelCash.css({"display": "block", "margin-left": "20px"});
      prelevementPart.css('display', 'block');
      prelevementRadio.css({"display": "block", "position": "absolute"});
      labelPrelevement.css({"display": "block", "margin-left": "20px"});
    } else if (!titre.hasClass('cash') && !titre.hasClass('prelevement')) {
      e.preventDefault();
      form.css('display', 'none');
      $('#myModalAddOffer').modal('hide');
      alert('Aucun mode de paiement disponible pour ce produit');
    }
  } else {
    $('#myModalAddOffer').modal('hide');
  }
});

$('.submitOffer').on('click', function (e) {
  e.preventDefault();
  var nextAction = $(this).attr('value');
  var form = $('#formSubmitOffer');
  var url = form.attr('action');
  var displayForm = form.css('display');
  var data = form.serialize();

  if (displayForm === 'block') {
    var isChecked = $("input[name='radio-duree-offer']").is(':checked');

    if (isChecked === false) {
      alert('Merci de sÃ©lectionner une valeur avant de continuer');
    } else {
      $('#nextAction').attr('value', nextAction);
      handleSubmit(nextAction, url, data);
    }
  } else {
    $('#nextAction').attr('value', nextAction);
    handleSubmit(nextAction, url, data);
  }
});

var submitTime = 0;

$(function () {
  // SÃ©lectionne le radio input si on clique sur l'image qui y correspond
  $('ul.payboxCard img').click(function () {
    var liParent = $(this).parent();
    liParent.find("input[type=radio]").click();
  });
  /*
  var time = setTimeout(function () {
    $('.flashbag').remove();
  }, 7000);
  */
});

function handleSubmit(nextAction, url, data) {
  if (nextAction === 'keepBuying') {
    $.ajax({
      type: "POST",
      url: url,
      data: data
    });
    $('#myModalAddOffer').modal('hide');
  } else {
    if (submitTime < 1) { // Si le form n'a jamais Ã©tÃ© soumis sur cette page on le soumet
      $("form#formSubmitOffer").submit();
    }
    submitTime++;
  }
}

var paywall = function(element) {
  var trigger = 'data-formula-trigger';
  var formula = 'data-formula';

  var $trigger = $("[" + trigger + "]");

  function _getData(el, data) {
    var data = $(el).find("[data-" + data + "]").data(data);
    return data;
  }

  function _changeData(el) {
    var profil = $(el).data();

    var formulas = {
      classique: _getData(el, 'formula-price-classique'),
      numeric: _getData(el, 'formula-price-numeric'),
      integral: _getData(el, 'formula-price-integral')

    }



    if(profil["formulaTrigger"] == "individual")
    {
      $('.item_numeric .price_for_other').css('display', "none");
      $('.item_numeric .price_for_individual').css('display', "block");
    }
    else
    {
      $('.item_numeric .price_for_other').css('display', "block");
      $('.item_numeric .price_for_individual').css('display', "none");
    }


    var formulasTotal = {
      classique: _getData(el, 'formula-total-classique'),
      numeric: _getData(el, 'formula-total-numeric'),
      integral: _getData(el, 'formula-total-integral')
    }

    $.each(formulas, function(key, value){
      var $formulaContainer = $("[" + formula + "='" + key + "']");
      var $formulaPrice = $formulaContainer.find('[data-formula-price]');
      var $formulaPriceTotal = $formulaContainer.find('[data-formula-price-total]');
      var $formulaPricePer = $formulaContainer.find('[data-formula-price-per]');
      var formatValue = value.toString().replace(".", ",");


      $formulaPrice.text(formatValue);

      if(value == formulasTotal[key]) {
        $formulaContainer.addClass('is-per-year');
        $formulaPricePer.text('par an');
      } else {
        $formulaPricePer.text('par mois');
        $formulaContainer.removeClass('is-per-year');
        $formulaPriceTotal.text(formulasTotal[key]);
      }
    });

    var formulasHref = {
      classique: _getData(el, 'formula-href-classique'),
      numeric: _getData(el, 'formula-href-numeric'),
      integral: _getData(el, 'formula-href-integral')
    }

    $.each(formulasHref, function(key, value){
      $('#formula-href-'+ key).attr('href', value);
    });
  }

  $trigger.on('click', function(e){
    _changeData(this)
  });

  $(document).ready(function(){
    if($($trigger).length) {
      _changeData($('[data-formula-trigger] [checked]').parents('[data-formula-trigger]'));
    }
  });

}
paywall();
